var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{staticClass:"d-flex flex-column"},[_vm._v(" "+_vm._s(_vm.$t("productDescription.digitalLabel"))+" "),_c('a',{staticClass:"anchor_tpl",attrs:{"target":"_blank","href":_vm.content},on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.content))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }